import React from "react"
import { PropsWithStyle } from "@rogue_4/types"
import classNames from "classnames"

import styles from "./index.module.less"

const CharacterBoard = React.forwardRef<
    HTMLDivElement,
    PropsWithStyle<{ type: "left" | "right"; characterKey: string }>
>(({ className, style, type, characterKey }, ref) => {
    return (
        <div
            ref={ref}
            className={classNames(
                styles.characterBoard,
                styles[type],
                className
            )}
            style={style}
        >
            <div className={styles.bg}></div>
            {type === "left" && (
                <div
                    className={classNames(
                        styles.front,
                        styles.nymph,
                        characterKey === "nymph" && styles.active
                    )}
                />
            )}
            {type === "right" && (
                <div
                    className={classNames(
                        styles.front,
                        styles.boss,
                        characterKey === "kalts" && styles.active
                    )}
                />
            )}
            {type === "right" && (
                <div
                    className={classNames(
                        styles.front,
                        styles.npc,
                        characterKey &&
                            characterKey !== "nymph" &&
                            characterKey !== "kalts" &&
                            styles.active
                    )}
                />
            )}
            <div className={styles.border}></div>
        </div>
    )
})
CharacterBoard.displayName = "CharacterBoard"

export default CharacterBoard
